

















































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { _moment as moment } from "@/utils/moment";
import { i18n } from "@/locales/settings";
import { LocalesFields } from "@/locales/translateInterface";

@Component
export default class CustomDatepicker extends Vue {
  @Prop() value!: Date;
  @Prop({ default: false }) minToday?: boolean;
  @Prop({ default: false }) includingAllDay?: boolean;
  @Prop({ default: () => i18n.tc(LocalesFields.Day) }) noLabelSelected?: string;
  @Prop({ default: true }) valueAsDate?: boolean;
  @Prop({ default: false }) todayButton?: false;
  @Prop({ default: false }) additionalIcon?: false;
  @Prop({ default: false }) resetButton?: boolean;
  @Prop({ default: false }) closeButton?: boolean;
  @Prop({ default: 1 }) startWeekday?: string | number;
  @Prop({ default: () => i18n.tc(LocalesFields.NextMonth) })
  labelNextMonth?: string;
  @Prop({ default: () => i18n.tc(LocalesFields.PreviousMonth) })
  labelPrevMonth?: string;
  @Prop({ default: () => i18n.tc(LocalesFields.NextYear) })
  labelNextYear?: string;
  @Prop({ default: () => i18n.tc(LocalesFields.PreviousYear) })
  labelPrevYear?: string;
  @Prop({ default: false }) isShowTime?: boolean;
  @Prop({ default: false }) isShowTimeColumn?: boolean;
  @Prop({ default: "md" }) size?: "lg" | "md" | "sm";
  @Prop({
    default: () => i18n.tc(LocalesFields.UseTheKeyboardArrowsToSelectDate)
  })
  @Prop({ default: true })
  isClearable?: boolean;
  labelHelp?: string;

  @Prop({ default: false }) disabled?: boolean;
  dateFormatOptions: Object = {
    year: "numeric",
    month: "long",
    day: "numeric"
  };

  @Prop() min?: Date | string;
  @Prop() max?: Date | string;
  newValue!: Date | undefined;
  time!: any;

  data() {
    return {
      time: undefined,
      labelHelp: undefined,
      minDateForCreateWebinar: undefined,
      newValue: undefined
    };
  }

  get locale() {
    let _locale = this.$i18n.locale;

    if (_locale === "ru-RU") _locale = "ru";
    if (_locale === "en-EN") _locale = "en";

    return _locale;
  }

  handleAddition() {
    this.$emit("handleAddition");
  }

  clearDate() {
    this.newValue = undefined;
    this.time = undefined;
  }

  @Watch("newValue")
  update() {
    if (this.time && this.newValue && this.isShowTime) {
      let hourStarted = moment(this.time, "HH:mm:ss").hour();
      let minuteStarted = moment(this.time, "HH:mm:ss").minute();
      this.newValue.setHours(hourStarted);
      this.newValue.setMinutes(minuteStarted);
    }

    if (this.includingAllDay) {
      this.newValue?.setHours(23);
      this.newValue?.setMinutes(59);
    }

    this.$emit("input", this.newValue);
  }

  @Watch("value")
  updateNewValue() {
    if (!this.value) {
      this.clearDate();
    } else if (this.value !== this.newValue) {
      this.newValue = this.value;
      this.newValue = new Date(this.value);
    }
  }

  @Watch("time")
  updateTime() {
    if (this.isShowTime && this.newValue) {
      let hourStarted = moment(this.time, "HH:mm:ss").hour();
      let minuteStarted = moment(this.time, "HH:mm:ss").minute();
      this.newValue.setHours(hourStarted);
      this.newValue.setMinutes(minuteStarted);
    }
  }

  setDate() {
    this.$emit("setDate");
  }

  setTime(date: Date) {
    let hr =
      date.getHours().toString().length === 1
        ? `0${date.getHours()}`
        : date.getHours();
    let min =
      date.getMinutes().toString().length === 1
        ? `0${date.getMinutes()}`
        : date.getMinutes();
    return `${hr}:${min}`;
  }

  created() {
    if (this.value) {
      this.newValue = new Date(this.value);
      this.time = this.setTime(this.newValue);
    }
    this.setDate();
  }
}
